/** @format */

import React from 'react';
import './style.scss';
const Img = () => {
  return (
    <div className='image'>
      <img
        src='/bidiptobose.png'
        alt='Bidipto Bose'
        height='auto'
        width='auto'
      />
    </div>
  );
};
export default Img;
